import { ArchetypeDefinition } from '../../archetypeTypes';

export const POWER_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'warrior',
        name: 'Warrior',
        description: 'Momentum, wave intensity, decisive energy flow.',
        category: 'Power',
        tags: ['action', 'momentum', 'courage'],
        weights: { energyLevel: 0.35, waveIntensity: 0.35, stability: 0.1, nodeCount: 0.2 }
    },
    {
        key: 'hero',
        name: 'Hero',
        description: 'Courageous stabilization of high energy toward purposeful outcomes.',
        category: 'Power',
        tags: ['courage', 'purpose', 'fortitude'],
        weights: { energyLevel: 0.3, stability: 0.3, waveIntensity: 0.25, edgeCount: 0.15 }
    },
    {
        key: 'ruler',
        name: 'Ruler',
        description: 'Ordering forces and stabilizing high-energy systems.',
        category: 'Power',
        tags: ['order', 'direction', 'authority'],
        weights: { stability: 0.35, nodeCount: 0.2, edgeCount: 0.2, energyLevel: 0.25 }
    },
    {
        key: 'champion',
        name: 'Champion',
        description: 'Directed effort that converts momentum into decisive breakthroughs.',
        category: 'Power',
        tags: ['drive', 'focus', 'breakthrough'],
        weights: { waveIntensity: 0.35, energyLevel: 0.3, stability: 0.2, nodeCount: 0.15 }
    }
];


